// import { channelNameMap, metricsMap } from '@/pages/opinion/community/constants';
import {
  channelNameMap,
  metricsMap,
} from '@/pages/opinion/pages/community/constants';
import { getRationPercentValue } from '@/pages/opinion/utils';

const platformConfig = (item) => {
  return channelNameMap[item.channel];
};

const valueConfig = (item, key, params) => {
  const metric = params?.metric;
  return ['peckCCV', 'avgCCV'].includes(metric)
    ? item[key]
    : Number(item[key]?.toFixed(2));
};

const headerTitle = (params) => {
  return metricsMap[params?.metric] || '指标';
};

const getRationPercent = (item) => {
  return getRationPercentValue(item.new, item.old) / 100;
};

export default [
  { header: 'Streamer', render: 'user_name' },
  { header: 'Channel', render: 'channel', renderHelper: [platformConfig] },
  { header: headerTitle, render: 'new', renderHelper: [valueConfig] },
  {
    header: 'Change %',
    render: 'ration_percent',
    renderHelper: [getRationPercent],
    numFmt: '0.00%',
  },
  { header: 'url', render: 'channel_url' },
];
